import { PaymentTypes } from '@grandvisionhq/api-client';
import { PaymentMethod } from '../../../models/cart-payment-methods/cart-payment-methods.js';

/**
 * The getRestPaymentMethodName function is being used to CONVERT the name of
 * the `payment method`, that is fetched by the getCartPaymentMethods query
 * TO the `payment method` name of the legacy api-client.
 *
 * @param {PaymentMethod} name - The name of the payment method.
 */ const getRestPaymentMethodName = (name)=>{
    switch(name){
        case PaymentMethod.BANCONTACT_CARD:
            return PaymentTypes.PaymentMethod.BancontactCard;
        case PaymentMethod.BANCONTACT_MOBILE:
            return PaymentTypes.PaymentMethod.BancontactMobile;
        case PaymentMethod.CASH_ON_DELIVERY:
            return PaymentTypes.PaymentMethod.CashOnDelivery;
        case PaymentMethod.CREDITCARD:
            return PaymentTypes.PaymentMethod.Creditcard;
        case PaymentMethod.FAKE:
            return PaymentTypes.PaymentMethod.Fake;
        case PaymentMethod.IDEAL:
            return PaymentTypes.PaymentMethod.Ideal;
        case PaymentMethod.KLARNA:
            return PaymentTypes.PaymentMethod.Klarna;
        case PaymentMethod.KLARNA_ACCOUNT:
            return PaymentTypes.PaymentMethod.KlarnaAccount;
        case PaymentMethod.MBWAY:
            return PaymentTypes.PaymentMethod.MBway;
        case PaymentMethod.MOBILE_PAY:
            return PaymentTypes.PaymentMethod.MobilePay;
        case PaymentMethod.MULTIBANCO:
            return PaymentTypes.PaymentMethod.Multibanco;
        case PaymentMethod.ONEY:
            return PaymentTypes.PaymentMethod.Oney;
        case PaymentMethod.PAYPAL:
            return PaymentTypes.PaymentMethod.Paypal;
        case PaymentMethod.SEPA_DIRECT_DEBIT:
            return PaymentTypes.PaymentMethod.SepaDirectDebit;
        case PaymentMethod.SWISH:
            return PaymentTypes.PaymentMethod.Swish;
        case PaymentMethod.APPLE_PAY:
            return PaymentTypes.PaymentMethod.ApplePay;
        default:
            return undefined;
    }
};

export { getRestPaymentMethodName };
//# sourceMappingURL=get-payment-method-name.js.map
